import Modal, {FULL_CONTENT_STYLE} from './Modal';
import Text from './Text';
import ICON_KAKAO_WEBTOON_LIGHT from '../../../public/static/icon-main-kw-logo-light.svg';
import ICON_KAKAO_WEBTOON from '../../../public/static/icon-main-kw-logo.svg';
import ICON_BOTTOM_TEXT_LIGHT from '../../../public/static/icon-splash-bottom-text-light.svg';
import ICON_BOTTOM_TEXT from '../../../public/static/icon-splash-bottom-text.svg';
import ICON_ORIGINAL_LIGHT from '../../../public/static/icon-splash-top-text-light.svg';
import ICON_ORIGINAL from '../../../public/static/icon-splash-top-text.svg';
import useTheme from '../hook/useTheme';
import {ITheme} from '../type';

interface IProps {
  title: string;
  subTitle: string;
  content: string;
}

export default function MaintenancePopup({title, subTitle, content}: IProps) {
  const {theme} = useTheme();
  const {mainIcon, topTextIcon, bottomTextIcon} =
    MAINTENANCE_POPUP_THEME_KEY_MAP[theme];

  return (
    <Modal
      contentStyle={FULL_CONTENT_STYLE}
      isOpen={true}
      onRequestClose={() => {}}
    >
      {
        <div
          className={cn(
            'absolute inset-0 w-full text-center z-1 animate-fadeIn',
            'bg-grey-01 light:bg-white'
          )}
        >
          <img src={mainIcon} className="block m-auto mt-54" alt="" />
          <img src={topTextIcon} className="block m-auto mt-10" alt="" />
          <div className="absolute w-full m-auto -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2">
            <Text
              className={cn(
                'tracking-[-0.51px] leading-[1.29]',
                's17-bold-white light:text-black'
              )}
            >
              {title}
            </Text>
            {subTitle && (
              <Text
                className={cn(
                  'mt-19 tracking-[-0.21px] leading-[1.53] max-w-[248px] m-auto',
                  's15-bold-white light:text-black'
                )}
              >
                {subTitle}
              </Text>
            )}
            <Text
              className={cn(
                'tracking-[-0.51px] leading-[1.4] max-w-[248px] mt-10 m-auto opacity-70',
                's15-regular-grey08'
              )}
            >
              {content}
            </Text>
          </div>
          <img
            className="fixed inset-x-0 m-auto bottom-30"
            src={bottomTextIcon}
            alt="desgined by kakao webtoon"
          />
        </div>
      }
    </Modal>
  );
}

type IMaintenancePopupThemeKey = 'mainIcon' | 'topTextIcon' | 'bottomTextIcon';

const MAINTENANCE_POPUP_THEME_KEY_MAP: {
  [key in ITheme]: {
    [key in IMaintenancePopupThemeKey]: string;
  };
} = {
  light: {
    mainIcon: ICON_KAKAO_WEBTOON_LIGHT,
    topTextIcon: ICON_ORIGINAL_LIGHT,
    bottomTextIcon: ICON_BOTTOM_TEXT_LIGHT,
  },
  dark: {
    mainIcon: ICON_KAKAO_WEBTOON,
    topTextIcon: ICON_ORIGINAL,
    bottomTextIcon: ICON_BOTTOM_TEXT,
  },
};
